import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden bg-paper" data-id="element-70">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 w-full" data-id="element-71">
        <div className="max-w-3xl" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-8" data-id="element-73">
            <span className="text-xs font-medium tracking-[0.2em] text-terracotta uppercase" data-id="element-74">
              STRATEGY • DESIGN • PRODUCT • CONTENT
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-6xl md:text-7xl lg:text-8xl font-serif font-normal text-ink leading-[1.05] mb-8" data-id="element-75">
            Move faster with{' '}
            <span className="italic text-terracotta" data-id="element-76">sprint-sized</span>
            <br data-id="element-77" />
            creative & product work
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-ink/70 max-w-2xl mb-12 leading-relaxed font-normal" data-id="element-78">
            Monthly retainers for founders. Four experts covering strategy,
            design, product, and content. Delivered in days, not weeks.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-79">
            <a href="#retainers" className="inline-flex items-center justify-center bg-ink text-white px-8 py-3.5 text-base font-medium hover:bg-ink/90 transition-colors group" data-id="element-80">
              View Pricing
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-81" />
            </a>
            <a href="#contact" className="inline-flex items-center justify-center border border-ink text-ink px-8 py-3.5 text-base font-medium hover:bg-ink hover:text-white transition-colors" data-id="element-82">
              Book a Call
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}